/* ------------------------------------------------------------------
 * Federica Oliva — scorrimento per sezioni (solo desktop)
 *
 * Un gesto della rotella porta alla sezione successiva, che si allinea
 * sotto l'intestazione. Le sezioni più alte dello schermo si leggono
 * normalmente: l'aggancio riprende quando si arriva in fondo.
 *
 * Sostituisce lo scroll-snap del browser, che con sezioni di altezze
 * diverse rimbalzava a scatti.
 * ------------------------------------------------------------------ */

(function () {
  'use strict';

  var MIN_WIDTH = 1025;
  var DURATION = 720;
  var COOLDOWN = 160; /* dopo l'arrivo, prima di accettare un nuovo gesto */
  var EDGE = 6; /* tolleranza in px sui bordi di sezione */

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function () {
    if (!document.body.classList.contains('template-index')) return;
    /* niente su touch: lì lo slancio del dito è già la navigazione */
    if (window.matchMedia('(hover: none)').matches) return;

    /* La misura si rifà a ogni gesto: restringendo la finestra il controllo
       fatto una volta sola al caricamento continuava a comandare lo scorrimento
       anche dove non serve più. */
    function wide() {
      return window.matchMedia('(min-width: ' + MIN_WIDTH + 'px)').matches;
    }

    var page = document.getElementById('page-content');
    if (!page) return;

    var sections = [];
    var animating = false;
    var lockUntil = 0;
    var raf = null;

    function headerHeight() {
      var el = document.getElementById('site-control');
      if (!el) return 0;
      var h = el.getBoundingClientRect().height;
      /* la barra è fissa: se fosse alta quanto mezzo schermo qualcosa non torna */
      return h > 0 && h < window.innerHeight * 0.3 ? Math.round(h) : 0;
    }

    function collect() {
      var vh = window.innerHeight;
      var top = window.pageYOffset;
      sections = [];

      Array.prototype.forEach.call(page.children, function (el) {
        if (!el.classList.contains('shopify-section')) return;
        var r = el.getBoundingClientRect();
        if (r.height < vh * 0.35) return; /* fasce corte: non sono una tappa */
        sections.push({
          el: el,
          top: Math.round(r.top + top),
          height: Math.round(r.height),
          /* l'esperienza immersiva gestisce da sé la rotella */
          skip: !!el.querySelector('.fo-immersive')
        });
      });
    }

    /* La sezione parte sempre subito sotto la barra: le sezioni sono tagliate
       per stare in una schermata, quindi non resta fascia vuota e l'inizio
       del contenuto è dove l'occhio se lo aspetta. */
    function offsetFor(s) {
      return Math.max(0, s.top - headerHeight());
    }

    function indexAt(y) {
      var probe = y + headerHeight() + 2;
      for (var i = sections.length - 1; i >= 0; i--) {
        if (sections[i].top <= probe) return i;
      }
      return 0;
    }

    function easeInOut(t) {
      return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
    }

    /* Le foto delle card arrivano mentre la pagina si muove e cambiano di
       poco l'altezza della sezione: all'arrivo si ricontrolla e si rimette in
       riga, se lo scarto è piccolo. */
    function retouch() {
      if (animating || Date.now() < lockUntil) return;
      collect();
      var y = window.pageYOffset;
      for (var i = 0; i < sections.length; i++) {
        if (sections[i].skip) continue;
        var aim = offsetFor(sections[i]);
        var gap = aim - y;
        if (Math.abs(gap) > 2 && Math.abs(gap) < 90) {
          glide(aim, false);
          return;
        }
      }
    }

    function glide(to, correct) {
      if (correct !== false) correct = true;
      var from = window.pageYOffset;
      var max = document.documentElement.scrollHeight - window.innerHeight;
      to = Math.max(0, Math.min(Math.round(to), max));
      if (Math.abs(to - from) < 2) return false;

      animating = true;
      var start = 0;

      function step(t) {
        if (!start) start = t;
        var p = Math.min(1, (t - start) / DURATION);
        window.scrollTo(0, from + (to - from) * easeInOut(p));
        if (p < 1) {
          raf = window.requestAnimationFrame(step);
        } else {
          raf = null;
          animating = false;
          lockUntil = Date.now() + COOLDOWN;
          if (correct) window.setTimeout(retouch, 90);
        }
      }

      raf = window.requestAnimationFrame(step);
      return true;
    }

    function busy() {
      var body = document.body;
      return (
        document.documentElement.classList.contains('fo-immersive-noscroll') ||
        body.classList.contains('fo-immersive-pinning') ||
        body.classList.contains('modal-active') ||
        body.classList.contains('nav-open')
      );
    }

    function onWheel(e) {
      if (e.ctrlKey || !wide() || busy()) return;
      if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;

      /* Il nastro (Ultimi arrivi) non deve sequestrare la rotella: lì la
         pagina scorre come sempre, anche mentre le card si muovono da sole. */
      if (e.target.closest && e.target.closest('[data-fo-marquee], .fo-rail')) return;

      /* dentro un pannello che scorre per conto suo la rotella resta sua */
      var node = e.target;
      while (node && node !== document.body) {
        if (node.scrollHeight - node.clientHeight > 8) {
          var style = window.getComputedStyle(node).overflowY;
          if (style === 'auto' || style === 'scroll') return;
        }
        node = node.parentNode;
      }

      collect();
      if (!sections.length) return;

      var down = e.deltaY > 0;
      var y = window.pageYOffset;
      var i = indexAt(y);
      var cur = sections[i];
      if (cur && cur.el.querySelector('[data-fo-marquee]')) return;

      if (animating || Date.now() < lockUntil) {
        e.preventDefault();
        return;
      }
      var head = headerHeight();
      var vh = window.innerHeight;

      /* Sezione più alta dello schermo: si scorre a schermate intere invece di
         lasciare la rotella libera, che lasciava l'occhio a metà contenuto.
         Solo quando è finita si passa alla sezione dopo. */
      var tall = cur.height + head > vh + EDGE;
      if (tall) {
        var page = vh - head;
        var head_pos = Math.max(0, cur.top - head);
        var tail_pos = cur.top + cur.height - vh;

        if (down && y < tail_pos - EDGE) {
          e.preventDefault();
          glide(Math.min(tail_pos, y + page));
          return;
        }
        if (!down && y > head_pos + EDGE) {
          e.preventDefault();
          glide(Math.max(head_pos, y - page));
          return;
        }
      }

      var next = down ? i + 1 : i - 1;

      /* la sezione immersiva si salta: ha una regia sua */
      while (sections[next] && sections[next].skip) next += down ? 1 : -1;

      /* Se la sezione corrente non è ancora al suo posto nel verso in cui si
         va, la prima tappa è lei: altrimenti la si salterebbe a metà. */
      var rest = offsetFor(cur);
      if (!tall && ((down && rest > y + EDGE * 4) || (!down && rest < y - EDGE * 4))) {
        e.preventDefault();
        glide(rest);
        return;
      }

      if (!sections[next]) {
        /* in coda alla pagina resta il piede: lo si raggiunge normalmente */
        return;
      }

      e.preventDefault();
      glide(offsetFor(sections[next]));
    }

    function stop() {
      if (!raf) return;
      window.cancelAnimationFrame(raf);
      raf = null;
      animating = false;
    }

    window.addEventListener('wheel', onWheel, { passive: false });
    /* tastiera, ricerca nella pagina e ancore devono poter interrompere */
    window.addEventListener('keydown', stop);
    window.addEventListener('mousedown', stop);
    window.addEventListener('resize', collect, { passive: true });
    window.addEventListener('load', collect);
    collect();
  });
})();
